import { Component, inject } from '@angular/core';
import {Router} from '@angular/router';
import {TherapeutService} from '../../../therapeut/therapeut.service';
import {Therapeut} from '../../../therapeut/therapeut';

@Component({
    templateUrl: './add-therapeut.page.html',
    styleUrls: ['./add-therapeut.page.scss'],
    standalone: false
})
export class AddTherapeutPage {
  private therapeutService = inject(TherapeutService);
  private router = inject(Router);

  private requestBusy = false;

  onCancelClicked(): void {
    this.navigateToTherapeuten();
  }

  onAddClicked(therapeut: Therapeut): void {
    if (!this.requestBusy) {
      this.requestBusy = true;
      this.therapeutService.postTherapeut$(therapeut)
        .subscribe(
          () => this.navigateToTherapeuten(),
          () => this.requestBusy = false,
          () => this.requestBusy = false,
        );
    }
  }

  private navigateToTherapeuten(): void {
    this.router.navigateByUrl('/therapeuten');
  }
}
